import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MAT_ICON_DEFAULT_OPTIONS, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PortalModule } from '@angular/cdk/portal';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { Platform } from '@angular/cdk/platform';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { NumberRoundingAsPower, SafeNumberPipe, SafeUrlPipe, SecondsToHoursMinutesSeconds, TeamMemberRolePipe } from './pipes';
import { PaginatorIntlService } from './paginator/paginator-intl.service';
import { QuillConfigurationService } from './rich-text-editor';
import { OutsideZoneEventManagerPlugin } from './outside-zone-events/outside-zone-event-manager-plugin';
import { ModalContentComponent } from './modal/modal-content.component';
import { ModalComponent } from './modal/modal.component';
import { CopyWhistleDirective } from './popover/whistle/copy-whistle.directive';

const COMMON_RE_EXPORTS = [
  MatMenuModule,
  MatCheckboxModule,
  MatSnackBarModule,
  MatIconModule,
  MatInputModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatButtonModule,
  MatSortModule,
  MatRadioModule,
  MatTooltipModule,
  MatDividerModule,
  MatSidenavModule,
  MatToolbarModule,
  MatSelectModule,
  MatRippleModule,
  MatListModule,
  PortalModule,
  MatCardModule,
  MatTabsModule,
  MatStepperModule,
  MatExpansionModule,
  MatBadgeModule,
  FormsModule,
  DragDropModule,
  ReactiveFormsModule,
  MatSlideToggleModule,
  MatDialogModule,
  MatPaginatorModule,
  MatTableModule,
  MatChipsModule,
  MatAutocompleteModule,
  SafeUrlPipe,
  SecondsToHoursMinutesSeconds,
  TeamMemberRolePipe,
  SafeNumberPipe,
  NumberRoundingAsPower,
  ModalContentComponent,
  ModalComponent,
  CopyWhistleDirective,
];

@NgModule({
  imports: [...COMMON_RE_EXPORTS],
  exports: [...COMMON_RE_EXPORTS],
  providers: [
    DecimalPipe,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        ...new MatDialogConfig(),
        hasBackdrop: true,
        backdropClass: 'dt-mat-dialog-backdrop',
        autoFocus: 'dialog',
      },
    },
    {
      provide: MAT_ICON_DEFAULT_OPTIONS,
      useValue: {
        fontSet: 'material-symbols-outlined',
      },
    },
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntlService,
    },
    {
      provide: EVENT_MANAGER_PLUGINS,
      multi: true,
      useClass: OutsideZoneEventManagerPlugin,
    },
  ],
})
export class WidgetsModule {
  constructor(platform: Platform, quillConfigurationService: QuillConfigurationService) {
    quillConfigurationService.configureQuill();

    if (platform.WEBKIT) {
      document.body.classList.add('dt-webkit');
    }
  }
}
